import type { GridColDef, GridValidRowModel } from '@mui/x-data-grid-pro';
import type { CustomGridColDef } from '../services';

export const isStringField = (field: string | number | symbol): field is string => typeof field === 'string';

export const extractColumnFields = <T extends GridValidRowModel>(
  columns: (GridColDef<T> | CustomGridColDef<T>)[],
): string[] => columns.map((col) => col.field).filter(isStringField);
